import React from 'react'
import Navbar from '../../../../Home/components/Navbar'
import TPSSvg from "../../../../utils-component/tpsSvg";
import hero from "../../../../../assets/images/old-hero.jpg"

type Props = {}

const OldHero = (props: Props) => {
  return (
    <section
      id="hero"
      className="bg-black bg-opacity-70"
      style={{ backgroundImage: `url(${hero})` }}
    >
      <Navbar />
      <div className="bg-black py-14 md:py-10 bg-opacity-70 max-h-screen overflow-hidden">
        <div className="flex md:flex-row">
          <div className="text-left px-6 md:p-12 md:pt-8 lg:p-14 lg:py-8">
            <p className="text-primary100 font-semibold text-lg">Challenges</p>
            <h1 className="text-white text-4xl md:text-5xl font-semibold md:font-bold text-left my-6 md:my-8 leading-[3.5rem]">
              Old, Slow and Useless!
            </h1>
            <p className="text-white text-semibold text-left mb-10 text-xl">
              Dated IT equipment can take a toll on your business.
            </p>
          </div>
          {/* svg/logo */}
          <div className="hidden md:block w-full md:w-1/2">
            <TPSSvg />
          </div>
        </div>
      </div>
    </section>
  );
}

export default OldHero